lmApp
  .filter('eventCorrectionFilter', function () {
    return function (items, criterion) {
      var tmp = {};
      for (var i in items) {
        var item = items[i];
        if (item.title.toLowerCase().indexOf(criterion.keyword.toLowerCase()) !== -1) {
          if (criterion.filter) {
            if (item._PrivateData.catchup2.correction._status
              && item._PrivateData.catchup2.correction._status.indexOf(criterion.filter) !== -1
              && item.is_catchup_available) {
              tmp[i] = item;
            }
          } else {
            tmp[i] = item;
          }
        }
      }
      return tmp;
    }
  });

lmApp
  .controller('Catchup20Controller', ['$scope', '$rootScope', '$timeout', '$interval', '$q', '$routeParams', '$location', 'AssetService', 'MetadataService', 'EpgService', 'CatchupService', 'ToastService',
    function ($scope, $rootScope, $timeout, $interval, $q, $routeParams, $location, AssetService, MetadataService, EpgService, CatchupService, ToastService) {
      $scope.loading = false;
      $scope.loadingFrame = false;
      $scope.catchupData = [];
      $scope.playerData = {};
      $scope.intervalForPreview = null;
      $scope.intervalForPreviewInAction = false;
      $scope._CSS = {
        frame: {}
      };

      $scope.activeChannel = {};
      $scope.search = {
        searchField: '',
        isShown: false,
        filter: ''
      };

      $scope._STREAM_TYPES_ATTRS = MetadataService._STREAM_TYPES_ATTRS;

      var parseCorrectionStatus = function (correction) {
        correction._date = moment(correction.update_time * 1000).format('D MMM YYYY - H:mm');

        switch (correction.state) {
          case 'success':
            correction._status = correction.state.toUpperCase();
            correction._color = 'green';
            break;

          case 'error':
            correction._status = 'ERROR: ' + (correction.error || '');
            correction._color = 'red';
            break;

          case 'processing':
            correction._status = 'IN PROGRESS';
            correction._color = 'amber';
            break;

          case 'pending':
            correction._status = correction.state.toUpperCase();
            correction._color = 'amber';
            break;

          default:
            correction._status = correction.state.toUpperCase();
            correction._color = 'black';
            break;
        }
      };

      var parseCorrectionProcess = function (correction, event) {
        if (!event) return {};

        correction.noCorrection = !event.corrections;
        correction.successCorrection = !!_.find(event.corrections, {state: 'success'});
        correction.processingCorrection = !!_.find(event.corrections, {state: 'processing'});
        correction.pendingCorrection = !!_.find(event.corrections, {state: 'pending'});
        correction.pendingCorrection = !!_.find(event.corrections, {state: 'pending'});
        correction.errorCorrection = event.corrections && event.corrections.length && event.corrections[event.corrections.length - 1].state === 'error';

        correction.correctionTime = correction.successCorrection ? _.findLast(event.corrections, {state: 'success'}).correction : 0;

        switch (true) {
          case (correction.noCorrection):
            correction._status = 'No correction';
            correction._class = 'tc-grey-600 bgc-grey-100';
            break;

          case (correction.errorCorrection):
            correction._status = 'Error: ' + (_.findLast(event.corrections, {state: 'error'}).error || '');
            correction._class = 'tc-red-700 bgc-red-50';
            break;

          case (correction.processingCorrection):
            correction._status = 'Correction in Progress';
            correction._class = 'tc-amber-700 bgc-amber-50';
            break;

          case (correction.successCorrection):
            correction._status = 'Correction Done';
            correction._class = 'tc-green-700 bgc-green-50';
            break;

          case (correction.pendingCorrection):
            correction._status = 'Correction Pending';
            correction._class = 'tc-lm-600 bgc-lm-100';
            break;

          default:
            correction._status = 'No correction';
            correction._class = 'tc-grey-600 bgc-grey-100';
            break;
        }

        return correction;
      };

      $scope._checkPreviewInterval = function (event) {
        if ($scope.intervalForPreview) $interval.cancel($scope.intervalForPreview);

        $scope.intervalForPreview = $interval(function () {
          if ($scope.intervalForPreviewInAction) return;

          $scope.intervalForPreviewInAction = true;

          CatchupService.GetCatchup2Preview(event)
            .then(function (result) {
              $scope.intervalForPreviewInAction = false;
              event._PrivateData.catchup2.preview = result.event.preview;

              if (result.event.preview && result.event.preview.state === 'prepared') {
                event._PrivateData.catchup2.preview._media = CatchupService.GetCatchup2PreviewMedia(event, result.event.preview);

                $interval.cancel($scope.intervalForPreview);
                $scope.intervalForPreview = null;
              }
            })
            .catch(function (reason) {
              $scope.intervalForPreviewInAction = false;

              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 15);
              $rootScope.debugInfo(reason, 'silent');
            });
        }, 1000);
      };

      $scope._checkCorrectionInterval = function (event) {
        if ($scope.intervalForCorrection) $interval.cancel($scope.intervalForCorrection);

        var needNewPreview = false;

        $scope.intervalForCorrection = $interval(function () {
          if ($scope.intervalForCorrectionInAction) return;

          $scope.intervalForCorrectionInAction = true;
          event._PrivateData.catchup2.correction = {};

          CatchupService.GetCatchup2Events([event.id])
            .then(function (collection) {
              event._PrivateData.catchup2.correction = parseCorrectionProcess(event._PrivateData.catchup2.correction, collection[0]);
              event._PrivateData.catchup2.correction.list = (collection[0] && collection[0].corrections) || [];
              event._PrivateData.catchup2.correction.list.forEach(parseCorrectionStatus);

              if (event._PrivateData.catchup2.correction.successCorrection && needNewPreview && !event._PrivateData.catchup2.correction.processingCorrection) {
                event._PrivateData.catchup2.correction_time = event._PrivateData.catchup2.correction.correctionTime;
                needNewPreview = false;
              }

              if (event._PrivateData.catchup2.correction.processingCorrection) {
                needNewPreview = true;
              }

              $scope.intervalForCorrectionInAction = false;
            }).catch(function (reason) {
            $scope.intervalForCorrectionInAction = false;

            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 15);
            $rootScope.debugInfo(reason, 'silent');
          });
        }, 15 * 1000);
      };

      $scope.getAllCatchupChannels = function () {
        $scope.loading = true;
        $rootScope.showLinearProgress('#catchupLoader');

        AssetService.GetAllAvailableCatchupChannels()
          .then(function (collection) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#catchupLoader');

            $scope.catchupData = collection.map(function (asset) {
              asset._deployed = {
                stream: asset.resources.filter(function (resource) {
                  if (resource.type === 'stream'
                    && resource.stream_type.indexOf('youtube') !== -1) {
                    asset._has_youtube = true;
                    resource.stream_type = 'youtube';
                  }

                  resource._stream_type = $scope._STREAM_TYPES_ATTRS[resource.stream_type];

                  return resource.type === 'stream' && resource.stream_type !== 'hls_catchup';
                }),
                poster: _.find(asset.resources, {category: 'poster_blueprint'}) && _.find(asset.resources, {category: 'poster_blueprint'}).is_deployed
              };

              asset._rentalStatus = asset.rental_status === "progress";
              if (!asset._rentalStatus) {
                asset._rentalWindow = MetadataService.Rental.Check(asset);
              }

              asset._catchup = _.find(asset.resources, {
                category: 'catchup',
                type: 'stream',
                stream_type: 'hls_catchup'
              });

              asset._npvr = _.find(asset.resources, {
                category: 'npvr',
                type: 'stream',
                stream_type: 'hls_catchup'
              });

              return asset;
            });

            if ($scope.routeChannelId) {
              var channel = _.find($scope.catchupData, {id: $scope.routeChannelId});
              if (channel) {
                $scope.setActiveChannel(channel);
              }
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#catchupLoader');

            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 15);
            $rootScope.debugInfo(reason, 'silent');
          });
      };

      $scope.setActiveChannel = function (channel) {
        if ($scope.loading) return;

        $location.search('channel_id', channel.id);

        $scope.activeChannel = angular.copy(channel);
        $scope.activeChannel._PrivateData = {};

        if ($scope.routeDate) {
          $scope.activeChannel._PrivateData.currentDate = moment.utc($scope.routeDate * 1000).startOf('day');
        } else {
          $scope.activeChannel._PrivateData.currentDate = moment.utc().startOf('day');
          $location.search('date', $scope.activeChannel._PrivateData.currentDate.unix());
        }

        $scope.activeChannel._PrivateData.currentEpgEvent = {};
        $scope.activeChannel._PrivateData.selectedDay = {
          start: parseInt($scope.activeChannel._PrivateData.currentDate.startOf('day').unix(), 10),
          end: parseInt($scope.activeChannel._PrivateData.currentDate.endOf('day').unix(), 10),
          date: $scope.activeChannel._PrivateData.currentDate.endOf('day').format("D, MMMM")
        };

        $scope.getEpgEvents();

        if ($scope.dateWatcher) $scope.dateWatcher();
        $scope.dateWatcher = $scope.$watch('activeChannel._PrivateData.currentDate', function (newValue, oldValue) {
          if (!_.isEmpty($scope.activeChannel) && !oldValue.isSame(newValue)) {
            $location.search('date', $scope.activeChannel._PrivateData.currentDate.unix());

            $scope.activeChannel._PrivateData.selectedDay = {
              start: parseInt(moment.utc(newValue).startOf('day').format('X'), 10),
              end: parseInt(moment.utc(newValue).endOf('day').format('X'), 10),
              date: moment.utc(newValue).endOf('day').format("D, MMMM")
            };
            $scope.getEpgEvents();
          }
        });
      };

      $scope.isActiveChannelSet = function () {
        return !_.isEmpty($scope.activeChannel);
      };

      $scope.clearActiveChannel = function () {
        if ($scope.loading) return;

        $scope.activeChannel = {};
        $location.search('channel_id', null);
      };

      $scope.isActiveChannel = function (id) {

        return $scope.activeChannel.id === id;
      };

      $scope.collapseProgramme = function () {
        $scope.activeChannel._PrivateData.currentEpgEvent = {};

        if ($scope.intervalForCorrection) $interval.cancel($scope.intervalForCorrection);
        $location.search('program_id', null);
      };

      $scope.setActiveProgram = function (activeChannel, event) {
        event._PrivateData.catchup2.preview = {};
        event._PrivateData.catchup2.references = {};

        if (event.id === activeChannel._PrivateData.currentEpgEvent.id) {
          activeChannel._PrivateData.currentEpgEvent = {};
          $scope.collapseProgramme();

          return;
        }

        if (event._PrivateData.isLocked) {
          if (moment.utc().unix() < event.end) {
            ToastService.Small({
              title: 'Sorry, you can\'t correct program in future',
              color: 'amber',
              icon: 'video-switch',
              blocked: true
            }, 1000 * 15);
          } else if (!event.is_catchup_available) {
            ToastService.Small({
              title: 'Sorry, catchup for this programme unavailable',
              color: 'amber',
              icon: 'video-switch',
              blocked: true
            }, 1000 * 15);
          }

          return;
        }

        activeChannel._PrivateData.currentEpgEvent = event;

        $scope.loading = true;
        $rootScope.showLinearProgress('#catchupLoader' + event.id);

        var allQ = {};

        allQ.references = CatchupService.GetCatchup2References(event)
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
          });

        allQ.preview = CatchupService.GetCatchup2Preview(event)
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
          });

        allQ.correction = CatchupService.GetCatchup2Events([event.id])
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
          });

        $q.all(allQ)
          .then(function (q) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#catchupLoader' + event.id);

            event._PrivateData.catchup2.preview = q.preview.event.preview;
            event._PrivateData.catchup2.correction_time = q.preview.event.start_correction;

            event._PrivateData.catchup2.references = q.references.program.references
              .map(function (reference) {
                reference._url = CatchupService.GetCatchup2ReferenceImg(event, reference);

                return reference;
              });

            event._PrivateData.catchup2.correction = parseCorrectionProcess(event._PrivateData.catchup2.correction, q.correction[0]);

            event._PrivateData.catchup2.correction.list = (q.correction[0] && q.correction[0].corrections) || [];

            event._PrivateData.catchup2.correction.list.forEach(parseCorrectionStatus);

            $scope._checkCorrectionInterval(event);

            if (q.preview.event.preview && q.preview.event.preview.state === 'prepared') {
              event._PrivateData.catchup2.preview._media = CatchupService.GetCatchup2PreviewMedia(event, q.preview.event.preview);
            } else if (q.preview.event.preview) {
              $scope._checkPreviewInterval(event);
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#catchupLoader' + event.id);

            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 15);
            $rootScope.debugInfo(reason, 'silent');
          });

        $location.search('program_id', event.id);
      };

      $scope.getCatchupMediaStream = function (event) {
        if (event.preview && event.preview.state === 'prepared') {
          return CatchupService.GetCatchup2PreviewMedia(event, event.preview);
        } else {
          return null;
        }
      };

      $scope.isActiveProgram = function (activeChannel, event) {
        return !_.isEmpty(activeChannel) && event.id === activeChannel._PrivateData.currentEpgEvent.id
      };

      $scope.toggleSearch = function () {
        $scope.search.isShown = !$scope.search.isShown;
        $timeout(function () {
          angular.element('input#channel_search').focus();
        }, 200);
      };

      $scope.getEpgEvents = function () {
        $scope.loading = true;
        $rootScope.showLinearProgress('#catchupLoader');

        //moment.utc().subtract(moment().utcOffset(), 'minutes').unix()
        EpgService.GetEpgEvents({id: $scope.activeChannel.epg_channel_id}, $scope.activeChannel._PrivateData.selectedDay)
          .then(function (collection) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#catchupLoader');

            $scope.activeChannel._PrivateData.events = collection.map(function (event) {
              event._PrivateData = {};
              event._PrivateData.catchup2 = {};
              event._PrivateData.startTime = moment.unix(event.start).format('HH:mm');
              event._PrivateData.endTime = moment.unix(event.end).format('HH:mm');
              event._PrivateData.isLocked = moment.utc().unix() < event.end || !event.is_catchup_available;
              event._PrivateData.isNow = moment.utc().unix() > event.start &&
                moment.utc().unix() < event.end;

              return event;
            });

            if (collection.length && $scope.routeProgramId) {
              var event = _.find($scope.activeChannel._PrivateData.events, {id: $scope.routeProgramId});
              if (event) {
                $scope.setActiveProgram($scope.activeChannel, event);
              }
            }

            if (collection.length) {
              CatchupService.GetCatchup2Events(_.map(collection, 'id'))
                .then(function (collection) {
                  $scope.activeChannel._PrivateData.events.forEach(function (event, index) {
                    event._PrivateData.catchup2.correction = {};

                    if (!collection[index]) collection[index] = {};
                    if (!collection[index].corrections) collection[index].corrections = [];

                    event._PrivateData.catchup2.correction = parseCorrectionProcess(event._PrivateData.catchup2.correction, collection[index]);
                    event._PrivateData.catchup2.correction.list = collection[index].corrections || [];
                  });
                })
                .catch(function (reason) {
                  ToastService.Small({
                    title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                    color: 'amber',
                    icon: 'server-off',
                    blocked: true
                  }, 1000 * 15);
                  $rootScope.debugInfo(reason, 'silent');
                });
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#catchupLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.deleteReferenceImg = function (event, reference) {
        if ($scope.loadingFrame) return;

        CatchupService.DeleteCatchup2ReferenceImg(event, reference)
          .then(function (result) {
            var index = event._PrivateData.catchup2.references.indexOf(reference);

            if (index !== -1) event._PrivateData.catchup2.references.splice(index, 1);
          })
      };

      $scope.setFilter = function (filter) {
        if (filter !== $scope.search.filter) {
          $scope.search.filter = filter;
        } else {
          $scope.search.filter = '';
        }
      };

      $scope.routeChannelId = null;
      if ($routeParams.channel_id) {
        $scope.routeChannelId = Number($routeParams.channel_id);
      }

      $scope.routeDate = null;
      if ($routeParams.date) {
        $scope.routeDate = Number($routeParams.date);
      }

      $scope.routeProgramId = null;
      if ($routeParams.program_id) {
        $scope.routeProgramId = Number($routeParams.program_id);
      }

      $scope.$on('$routeUpdate', function () {
        if ($scope.routeChannelId && !$routeParams.channel_id) {
          $scope.clearActiveChannel();
          $location.search('date', null);
          $location.search('program_id', null);
        }
        $scope.routeChannelId = Number($routeParams.channel_id) || null;

        $scope.routeDate = Number($routeParams.date) || null;

        if ($routeParams.program_id && !$routeParams.program_id) {
          $scope.collapseProgramme();
        }

        $scope.routeProgramId = Number($routeParams.program_id) || null;
      });

      $scope.getAllCatchupChannels();

      $scope.$on('destroy', function () {
        if ($scope.dateWatcher) $scope.dateWatcher();
      })
    }
  ]);
